import { render, staticRenderFns } from "./InpageNav.vue?vue&type=template&id=bf1bafba&scoped=true"
import script from "./InpageNav.vue?vue&type=script&lang=js"
export * from "./InpageNav.vue?vue&type=script&lang=js"
import style0 from "./InpageNav.vue?vue&type=style&index=0&id=bf1bafba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1bafba",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomDropdown: require('/vercel/path0/components/ui/CustomDropdown.vue').default})
